import { initApiClient } from '~/utils/api';

export default defineNuxtPlugin({
  name: 'api-client',
  setup() {
    const config = useRuntimeConfig();
    initApiClient(config.public.apiBaseUrl as string || 'https://server.musicmint.ai');
  },
});
